/* eslint-disable camelcase */
import $i18n from '@/modules/FPKG-20000-Util/lang';

const Account = {
  account: {
    id: 'p9_ton_deal_account',
    label: $i18n.t('Transaction.apply.deal_account'),
    rules: {
      required: true,
      message: $i18n.t('Util.isRequired', {
        label: $i18n.t('Transaction.apply.deal_account'),
      }),
    },
  },

  status: {
    label: 'Util.status',
    id: 'p9_ton_status',
    options: [
      {
        value: 'APPLY',
        label: 'Transaction.APPLY',
        icon: 'fas fa-check',
        color: 'success',
      },
      {
        value: 'REPLY',
        label: 'Transaction.REPLY',
        icon: 'fas fa-check',
        color: 'warning',
      },
      {
        value: 'ARCHIVED',
        label: 'Transaction.ARCHIVED',
        icon: 'fas fa-folder',
        color: 'Info',
      },
      {
        value: 'CANCEL',
        label: 'Transaction.CANCEL',
        icon: 'fas fa-ban',
        color: 'danger',
      },
    ],
    options2: [
      {
        value: 'APPLY',
        label: 'Transaction.APPLY',
        icon: 'fas fa-check',
        color: 'success',
      },
      {
        value: 'REPLY',
        label: 'Transaction.REPLY',
        icon: 'fas fa-check',
        color: 'warning',
      },
    ],
    options3: [
      {
        value: 'ARCHIVED',
        label: 'Transaction.ARCHIVED',
        icon: 'fas fa-folder',
        color: 'Info',
      },
      {
        value: 'CANCEL',
        label: 'Transaction.CANCEL',
        icon: 'fas fa-ban',
        color: 'danger',
      },
    ],
  },

  check_status: {
    label: 'Transaction.check_status',
    id: 'p9_ton_status',
    options: [
      {
        value: 'PASS',
        label: 'Transaction.PASS',
        icon: 'fas fa-check',
        color: 'success',
      },
      {
        value: 'FAIL',
        label: 'Transaction.FAIL',
        icon: 'fas fa-ban',
        color: 'danger',
      },
    ],
  },


  created_at: {
    label: $i18n.t('Account.manage.created_at'),
    id: 'p9_ton_created_at',
  },


  type: {
    label: 'Util.type',
    id: 'p9_ton_type',
    options: [
      {
        value: 'STORED',
        label: 'Transaction.apply.stored',
        icon: 'fas fa-piggy-bank',
        color: 'success',
      },
      {
        value: 'AUCTION',
        label: 'Transaction.apply.auction',
        icon: 'fas fa-hand-pointer',
        color: 'danger',
      },
    ],
  },


  amount: {
    id: 'p9_ton_amount',
    label: $i18n.t('Transaction.apply.amount'),
  },

};

export default Account;
